import { useEffect, useState } from "react";

/**
 * Hook này trả về một giá trị (number) thay đổi mỗi interval ms, giúp trigger re-render.
 * @param interval Thời gian lặp lại (ms), mặc định 60000ms = 1 phút
 */
export function useIntervalRerender(interval: number = 60000): number {
    const [tick, setTick] = useState(Date.now());
    useEffect(() => {
        const timer = setInterval(() => {
            setTick(Date.now());
        }, interval);
        return () => clearInterval(timer);
    }, [interval]);
    return tick;
}
